export const COMMUNITIES_RESOURCE = 'communities';
export const COMMUNITY_RESOURCE = 'community';
export const CREATE_COMMUNITY_RESOURCE = 'createCommunity';
export const UPDATE_COMMUNITY_RESOURCE = 'updateCommunity';
export const REMOVE_COMMUNITY_RESOURCE = 'removeCommunity';

export const COMMUNITY_ROLES_RESOURCE = 'communityRoles';
export const COMMUNITY_ROLE_RESOURCE = 'communityRole';
export const CREATE_COMMUNITY_ROLE_RESOURCE = 'createCommunityRole';
export const UPDATE_COMMUNITY_ROLE_RESOURCE = 'updateCommunityRole';
export const REMOVE_COMMUNITY_ROLE_RESOURCE = 'removeCommunityRole';

export const COMMUNITY_MEMBERS_RESOURCE = 'communityMembers';
export const COMMUNITY_MEMBER_RESOURCE = 'communityMember';
export const CREATE_COMMUNITY_MEMBER_RESOURCE = 'createCommunityMember';
export const UPDATE_COMMUNITY_MEMBER_RESOURCE = 'updateCommunityMember';
export const REMOVE_COMMUNITY_MEMBER_RESOURCE = 'removeCommunityMember';

export const COMMUNITY_MEMBER_ROLES_RESOURCE = 'communityMemberRoles';
export const ADD_COMMUNITY_MEMBER_ROLE_RESOURCE = 'addCommunityMemberRole';
export const UPDATE_COMMUNITY_MEMBER_ROLES_RESOURCE = 'updateCommunityMemberRoles';
export const REMOVE_COMMUNITY_MEMBER_ROLE_RESOURCE = 'removeCommunityMemberRole';

export const COMMUNITY_SUITES_RESOURCE = 'communitySuites';
export const COMMUNITY_SUITE_RESOURCE = 'communitySuite';
export const CREATE_COMMUNITY_SUITE_RESOURCE = 'createCommunitySuite';
export const UPDATE_COMMUNITY_SUITE_RESOURCE = 'updateCommunitySuite';
export const REMOVE_COMMUNITY_SUITE_RESOURCE = 'removeCommunitySuite';

export const COMMUNITY_APPS_RESOURCE = 'communityApps';
export const COMMUNITY_APP_RESOURCE = 'communityApp';
export const CREATE_COMMUNITY_APP_RESOURCE = 'createCommunityApp';
export const UPDATE_COMMUNITY_APP_RESOURCE = 'updateCommunityApp';
export const REMOVE_COMMUNITY_APP_RESOURCE = 'removeCommunityApp';

export const COMMUNITY_APP_FORM_NAME = 'communityAppDetail';

export const APPINSTALLATIONS_RESOURCE = 'appInstallations';
export const APPINSTALLATION_RESOURCE = 'appInstallation';

export const RELATIONS_RESOURCE = 'relations';
export const RELATION_RESOURCE = 'relation';
export const CREATE_RELATION_RESOURCE = 'createRelation';
export const UPDATE_RELATION_RESOURCE = 'updateRelation';
export const REMOVE_RELATION_RESOURCE = 'removeRelation';
export const SOURCES_RESOURCE = 'sources';
export const TARGETS_RESOURCE = 'targets';

export const COMMUNITY_ONBOARDING_TEMPLATES_RESOURCE = 'communityOnboardingTemplates';
export const ONBOARDING_TEMPLATES_RESOURCE = 'onboardingTemplates';
export const ONBOARDING_TEMPLATE_RESOURCE = 'onboardingTemplate';
export const CREATE_ONBOARDING_TEMPLATE_RESOURCE = 'createOnboardingTemplate';
export const UPDATE_ONBOARDING_TEMPLATE_RESOURCE = 'updateOnboardingTemplate';
export const REMOVE_ONBOARDING_TEMPLATE_RESOURCE = 'removeOnboardingTemplate';
export const APPLY_ONBOARDING_TEMPLATE_RESOURCE = 'applyOnboardingTemplate';

export const COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE = 'communityIdentificationCodeTypes';
export const COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE = 'communityIdentificationCodeType';
export const CREATE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE =
  'createCommunityIdentificationCodeType';
export const UPDATE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE =
  'updateCommunityIdentificationCodeType';
export const REMOVE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE =
  'removeCommunityIdentificationCodeType';

export const JOIN_REQUESTS_RESOURCE = 'joinRequests';
export const JOIN_REQUEST_RESOURCE = 'joinRequest';
export const DENY_JOIN_REQUEST_RESOURCE = 'denyJoinRequest';
export const MARK_UNIQUE_JOIN_REQUEST_RESOURCE = 'markUniqueJoinRequest';

export const ONBOARDING_TEMPLATE_FORM_NAME = 'onboardingTemplate';

export const INFINITE_SCROLL = { loader: 'blocked' };

export const ACTIONS = {
  NEW: 'new',
  EDIT: 'edit',
};

export const APP_TABS = {
  DETAILS: 'details',
  FEATURES: 'features',
};

export const FEATURE_TABS = {
  DETAILS: 'details',
  ROLES: 'roles',
};

export const COMMUNITY_DETAIL_TABS = {
  DETAILS: 'details',
  ROLES: 'roles',
  MEMBERS: 'members',
  SUITES: 'suites',
  APPS: 'apps',
  RELATIONS: 'relations',
  ONBOARDING_TEMPLATES: 'onboarding-templates',
  JOIN_REQUESTS: 'join-requests',
  IDENTIFICATION_CODE_TYPES: 'identification-code-types',
  NOTIFICATION_SETTINGS: 'notification-settings',
  HOST_URLS: 'host-urls',
  LEGAL_AND_TEXTS: 'legal-texts',
};

export const COMMUNITY_TAB_ACTIONS = {
  EDIT_COMMUNITY: 'edit-community',
  LINK_MEMBER: 'link-member',
  EDIT_MEMBER: 'edit-member',
  APPLY_ONBOARDING_TEMPLATE: 'apply-onboarding-template',
  NEW_MEMBER: 'new-member',
  NEW_ROLE: 'new-role',
  EDIT_ROLE: 'edit-role',
  VIEW_ORGANISATIONS: 'view-organisations',
  NEW_SUITE: 'new-suite',
  EDIT_SUITE: 'edit-suite',
  NEW_APP: 'new-app',
  EDIT_APP: 'edit-app',
  VIEW_APP: 'view-app',
  MANAGE_APP_CLIENTS: 'manage-app-clients',
  NEW_RELATION: 'new-relation',
  EDIT_RELATION: 'edit-relation',
  NEW_ONBOARDING_TEMPLATE: 'new-onboarding-template',
  EDIT_ONBOARDING_TEMPLATE: 'edit-onboarding-template',
  ACCEPT_JOIN_REQUEST: 'accept-join-request',
  EDIT_JOIN_REQUEST: 'edit-join-request',
  NEW_IDENTIFICATION_CODE_TYPE: 'new-identification-code-type',
  EDIT_IDENTIFICATION_CODE_TYPE: 'edit-identification-code-type',
};
